<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">gynecology</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('mating.Matings') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>                               
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">
                                <div class="btn-group" v-if="userRoleName === 'Keeper'">
                                    <button class="btn btn-sm bg-gradient-success text-nowrap" @click="downloadBirthList">
                                        {{ $t('mating.Birthlist') }}
                                    </button>
                                </div>
                                <div class="btn-group" v-if="userRoleName === 'Keeper' || userRoleName === 'AssociationAdmin'">
                                    <router-link
                                        :to="associationId ? { name: 'New Mating', params: { id: associationId } } : ''"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                        >
                                    {{ $t('mating.Add_mating') }}
                                    </router-link>
                                </div>
                                <div class="btn-group" v-if="userRoleName !== 'Keeper' && userRoleName !== 'AssociationAdmin'">
                                    <router-link
                                        :to="associationId ? `/mating/create/${associationId}` : '#'"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                    >
                                        {{ $t('mating.Add_mating') }}
                                    </router-link>

                                    <!-- Dropdown toggle -->
                                    <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                    </button>

                                    <!-- Dropdown menu -->
                                    <ul class="dropdown-menu dropdown-menu-end  custom-association-dropdown">
                                        <li @click="associationId = ''">
                                            <span class="dropdown-item text-muted">
                                            {{ $t('settings.Select_association') }}
                                            </span>
                                        </li>
                                        <li><hr class="dropdown-divider" /></li>
                                        <li
                                            v-for="item in associations"
                                            :key="item.id"
                                            @click="associationId = item.id"
                                            class="dropdown-item"
                                        >
                                            {{ item.abbreviation }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table
                            :key="'page-' + currentPage"
                            id="mating-list"
                            class="table table-flush"
                            v-if="tableVisible"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.UBN') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Female_tagnumber') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.Birth_date') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.No_of_born') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('mating.No_of_alive') }}</p></th>
                                    <th></th>                                    
                                </tr>
                            </thead>                            
                            <tbody>
                                <template v-for="(group, groupIndex) in groupedMatings" :key="groupIndex">
                                    <tr>
                                         <td colspan="9" class="bg-light text-muted small py-2">
                                            <div class="d-flex justify-content-between align-items-center w-100 px-3">                                                
                                                <span>
                                                    {{ $t('mating.Group') }} {{ groupIndex + 1 }} | {{ $t('mating.Date') }} {{ formatDate(group[0].dateFrom) }} {{ $t('mating.To') }} {{ formatDate(group[0].dateTo) }} | {{ $t('mating.Male') }}: {{ group[0].maleStudbookNumber }}
                                                </span>
                                                <span v-if="group[0].maleLeased" class="text-green">
                                                   ({{ $t('mating.Male_leased_from_UBN') }} {{ group[0].maleLeaseUbn }})
                                                </span>
                                                <div v-if="group && group.length && !group[0].newGroupGuid">
                                                    <!-- Edit Group -->
                                                    <button style="margin-bottom: 0px !important;" :data-id="group[0].groupGuid" class="btn btn-sm bg-gradient-success me-2 edit-button" :title="$t('common.Edit')">
                                                        <i class="material-symbols-rounded text-white" style="font-size: 0.8rem;">edit</i>
                                                    </button>
                                                    <!-- Delete Group -->
                                                    <button style="margin-bottom: 0px !important;" :data-id="group[0].groupGuid" @click="deleteGroup(group[0].groupGuid)" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                        <i class="material-symbols-rounded text-white" style="font-size: 0.8rem;">delete</i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="item in group" :key="item.id"
                                        :class="{
                                            'dead-animal-row': item.newGroupGuid && item.departureTo && item.reasonId === '6c49338f-78de-4e34-a4f8-f51796ff4049',
                                            'transferred-animal-row': item.newGroupGuid && item.departureTo && item.reasonId === '5f11a1a4-b075-4098-a5cf-31b9c9c36e17'
                                        }"
                                    >
                                        <td class="text-sm font-weight-normal">{{ item.ubn }}</td>                                        
                                        <td class="text-sm font-weight-normal">{{ item.femaleStudbookNumber }}</td>                                        
                                        <td class="text-sm font-weight-normal">{{ formatDate(item.birthDate) }}</td>
                                        <td class="text-sm font-weight-normal">{{ item.noOfBirth }}</td>
                                        <td class="text-sm font-weight-normal">{{ item.noOfAlive }}</td>
                                        <td>
                                        <div class="float-end">
                                            <span v-if="item.departureTo" class="small me-2">{{ $t('departure.Departure_UBN') }}: {{ item.departureTo }}</span>
                                            <span v-if="item.departureTo && item.reasonId === '6c49338f-78de-4e34-a4f8-f51796ff4049'" class="badge bg-danger">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">church</i>
                                            </span>
                                            <span v-if="item.departureTo && item.reasonId === '5f11a1a4-b075-4098-a5cf-31b9c9c36e17'" class="badge bg-warning">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">output</i>
                                            </span>  
                                            <button
                                                 v-if="item.offspringAdded && !item.newGroupGuid"
                                                :data-id="item.id"
                                                class="mt-2 mb-0 btn bg-gradient-success btn-sm registeredoffspring-button"
                                                :title="$t('common.Birth')"
                                                >
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">
                                                    visibility
                                                </i>
                                            </button>
                                            <button
                                                v-if="!item.offspringAdded && !item.newGroupGuid"
                                                :data-id="item.id"
                                                class="mt-2 mb-0 btn bg-gradient-success btn-sm registerbirth-button"
                                                :title="$t('common.Add_new_born')"
                                                >
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">
                                                    add_business
                                                </i>
                                            </button>
                                        </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-between align-items-center w-100 mt-3 px-3 mb-4">

                            <div class="small text-muted">
                                Tonen
                                {{ totalGroups === 0 ? 0 : (currentPage - 1) * perPage + 1 }}
                                t/m
                                {{ Math.min(currentPage * perPage, totalGroups) }}
                                van
                                {{ totalGroups }}
                                items
                            </div>

                            <div class="btn-group pagination-circles ms-auto">

                                <!-- Prev -->
                                <button
                                    class="page-circle"
                                    :class="{ disabled: currentPage === 1 }"
                                    @click="changePage(currentPage - 1)"
                                    :disabled="currentPage === 1"
                                >
                                    ‹
                                </button>

                                <!-- Visible pages -->
                                <button
                                    v-for="p in visiblePages"
                                    :key="p"
                                    class="page-circle"
                                    :class="{ active: p === currentPage, dots: p === '...' }"
                                    @click="p !== '...' && changePage(p)"
                                >
                                    {{ p }}
                                </button>

                                <!-- Next -->
                                <button
                                    class="page-circle"
                                    :class="{ disabled: currentPage === totalPages }"
                                    @click="changePage(currentPage + 1)"
                                    :disabled="currentPage === totalPages"
                                >
                                    ›
                                </button>

                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"

export default {
    name: 'Mating_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            matings: [],
            gets: [],            
            dataTableInstance: null,
            tableVisible: false,
            choicesInstanceAssociation: null,
            currentPage: 1,
            perPage: 5
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);            
            await this.loadMatings();
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {         
        async changePage(page) {

            if (page < 1 || page > this.totalPages) {
                return;
            }

            // destroy datatable BEFORE vue rerender
            if (this.dataTableInstance) {

                try {
                    this.dataTableInstance.destroy();
                } catch (e) {
                    console.warn(e);
                }

                this.dataTableInstance = null;
            }

            this.tableVisible = false;

            await this.$nextTick();

            this.currentPage = page;

            this.tableVisible = true;

            await this.$nextTick();

            this.initDataTable();
        },      
        async initDataTable() {

            await nextTick();

            const table = document.querySelector("#mating-list");

            if (!table) {
                console.warn("Table not found");
                return;
            }

            // destroy safely
            if (this.dataTableInstance) {

                try {
                    this.dataTableInstance.destroy();
                } catch (e) {
                    console.warn(e);
                }

                this.dataTableInstance = null;

                await nextTick();
            }

            // create datatable ONLY ONCE
            this.dataTableInstance = new DataTable(table, {

                searchable: true,

                paging: false,

                perPageSelect: false,

                fixedHeight: false,

                sortable: false,

                info: false,

                labels: {
                    search: this.$t('datatable.Search'),
                    noRows: this.$t('datatable.NoRows'),
                    placeholder: this.$t('common.Search')
                }
            });

            // remove duplicate listeners
            table.removeEventListener('click', this.handleTableClick);

            table.addEventListener('click', this.handleTableClick);
        },
        handleTableClick(event) {

            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.closest('.edit-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                    
                    this.$router.push({ name: 'Edit Mating', params: { id: id }, query: { type: 'group' } });
                } else {
                    this.$router.push({ name: 'Edit Mating', params: { id: id }, query: { type: 'single' } });
                }       
            } else if (event.target.closest('.registerbirth-button')) {
                this.$router.push({ name: 'Register Birth', params: { id } });
            }  else if (event.target.closest('.registeredoffspring-button')) {
                this.$router.push({
                        name: 'Animal',
                        query: {
                            matingId: id
                        }
                    });
            } else if (event.target.classList.contains('delete-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                        
                    this.deleteGroup(id);
                } else {                                        
                    this.deleteMatingModal(id);
                }
            }
        },
        async loadMatings() {
            try {

                let response;
                
                const role = this.$store.state.roleName;
                const keeperLocationId = this.$store.state.keeperLocationId;
                const keeperAssociationId = this.$store.state.keeperAssociationId;
                const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

                let associationId = this.$route.query.associationId
                let ubnId = this.$route.query.ubnId

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await axios.get("mating/getall");
                } else if (role === 'AssociationAdmin') {
                    associationId = associationAdminAssociationId;
                    response = await axios.get(`/mating/getbyassociation?associationId=${associationId}`)

                    this.associationId = associationId;
                } else if (role === 'Keeper' && keeperLocationId && keeperAssociationId) {
                    ubnId = keeperLocationId;
                    associationId = keeperAssociationId;

                    this.ubnId = ubnId;
                    this.associationId = associationId;

                    response = await axios.get(`/mating/getbyubn?ubn=${ubnId}`)
                } else {
                    // Optional: handle case where Keeper has no location selected
                    console.warn('No location assigned for Keeper');
                    return;
                }

                this.gets = response.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                const rawData = Array.isArray(this.gets.data) ? this.gets.data : [];

                // 1. Destroy DataTable if it exists
                if (this.dataTableInstance) {
                    //this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }

                // 2. Force table unmount
                this.tableVisible = false;

                // 3. Wait for DOM update to unmount table
                await this.$nextTick();

                // 4. Set matings data
                this.matings = rawData;

                // 5. Force table mount
                this.tableVisible = true;

                // 6. Wait for DOM update to mount table
                await this.$nextTick();

                // 7. Init DataTable if data is present
                if (rawData.length > 0) {
                    this.initDataTable();
                } else {
                    this.initDataTable();
                    this.$showSuccess('errors.No_matings_found');
                }

            } catch (e) {
                console.error("Exception occurred in loadMatings()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },
        deleteGroup(groupGuid) {
            if (!groupGuid) {
                this.$showError('errors.Group_id_is_missing');
                return;
            }

            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_group'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete(`Mating/group/${groupGuid}`);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {

                                    this.$showSuccess('errors.Success_mating_group_deleted_successfully');
                                    await this.loadMatings();
                                    
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {
                                this.$showError('errors.Contact_system_admin');
                            }
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                }); 
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');                    
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },        
        async deleteMatingModal(id) {
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Mating/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Mating/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {
                                        this.matings = fetchResult.data;

                                        if (this.dataTableInstance && typeof this.dataTableInstance.rows === 'function') {                                            
                                            this.dataTableInstance.rows().remove();                                            
                                        } else {
                                            console.log('DataTable instance is not valid or not initialized');
                                        }

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated animal list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        },
        async downloadBirthList() {
            try {
                this.$store.commit('setShowLoading', true);   

                let response;
                
                const role = this.$store.state.roleName;
                const keeperLocationId = this.$store.state.keeperLocationId;
                const keeperAssociationId = this.$store.state.keeperAssociationId;
                const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

                let associationId = this.$route.query.associationId
                let ubnId = this.$route.query.ubnId

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await axios.get("mating/getallbirthlist");
                } else if (role === 'AssociationAdmin') {
                    associationId = associationAdminAssociationId;
                    response = await axios.get(`/mating/getbirthlistbyassociation?associationId=${associationId}`)

                    this.associationId = associationId;
                } else if (role === 'Keeper' && keeperLocationId && keeperAssociationId) {
                    ubnId = keeperLocationId;
                    associationId = keeperAssociationId;

                    this.ubnId = ubnId;
                    this.associationId = associationId;

                    response = await axios.get(`/mating/getbirthlistbyubn?ubn=${ubnId}`)
                } else {
                    // Optional: handle case where Keeper has no location selected
                    console.warn('No location assigned for Keeper');
                    return;
                }

                const result = response.data;

                if (!result?.success) {
                    this.$showError(this.$t('errors.Contact_system_admin'));
                    return;
                }

                const births = result.data || [];

                if (!births.length) {
                    this.$showError("No birthlist found");
                    return;
                }

                const first = births[0];

                const doc = new jsPDF("p", "mm", "a4");
                
                /* --- LOGO --- */
                if (first.associationLogoBase64) {
                    doc.addImage(first.associationLogoBase64, 'PNG', 10, 8, 30, 15);
                }

                /* --- ASSOCIATION NAME (under logo) --- */
                doc.setFontSize(10);
                doc.setTextColor(100); // slightly grey like screenshot
                doc.text(first.associationName ?? '', 10, 26);

                /* --- LEFT DETAILS --- */
                doc.setFontSize(9);
                doc.setTextColor(120);

                doc.text(`Stamboeknr.: ${first.breederRvonumber ?? ''}`, 10, 34);
                doc.text(`UBN: ${first.ubn ?? ''}`, 10, 39);
                doc.text(`Bedrijfsnaam: ${first.breederName ?? ''}`, 10, 44);

                /* --- CENTER TITLE --- */
                doc.setFontSize(16);
                doc.setTextColor(60);
                doc.text(this.$t('mating.Birthlist'), 105, 38, { align: "center" });

                /* --- RIGHT DETAILS --- */
                doc.setFontSize(9);
                doc.setTextColor(120);

                //doc.text(first.breederName ?? '', 200, 34, { align: "right" });
                doc.text(`${first.locationAddress ?? ''} ${first.locationHousenumber ?? ''}`, 200, 39, { align: "right" });
                doc.text(`${first.locationPostalcode ?? ''} ${first.locationCity ?? ''}`, 200, 44, { align: "right" });

                /* --- RESET COLOR --- */
                doc.setTextColor(0);

                /* --- START TABLE POSITION --- */
                let startY = 50;
                
                for (const birth of births) {

                     const headerRow = [
                        birth.maleAnimalNumber ?? "",
                        birth.femaleAnimalNumber ?? "",
                        birth.birthDate ?? "",
                        birth.noOfBirth ?? "",
                        birth.noOfAlive ?? ""
                    ];

                    autoTable(doc, {
                        startY,
                        margin: { left: 10, right: 10 },
                        head: [[
                            this.$t('mating.Male_number'),
                            this.$t('mating.Female_number'),
                            this.$t('mating.Birth_date'),
                            this.$t('mating.No_of_born'),
                            this.$t('mating.No_of_alive')
                        ]],
                        body: [headerRow],
                        theme: "grid",
                        styles: { fontSize: 8 }
                    });

                    startY = doc.lastAutoTable.finalY + 6;

                    /* --- 4 dotted rows ABOVE Opmerkingen --- */
                    const rowHeight = 8;
                    const startX = 10;

                    for (let i = 0; i < 4; i++) {
                        const y = startY + (i * rowHeight);

                        doc.setFontSize(8);

                        // Labels
                        doc.text("Gesl.", startX, y);
                        doc.text("LevensNr.", startX + 35, y);
                        doc.text("Extra info.", startX + 95, y);

                        doc.setLineWidth(0.2);
                        doc.setDrawColor(150);
                        doc.setLineDash([1, 2]);

                        // Dotted lines
                        doc.setLineDash([1, 2]);

                        // Gesl line
                        doc.line(startX + 9, y, startX + 32, y);

                        // LevensNr line
                        doc.line(startX + 50, y, startX + 90, y);

                        // Extra info line
                        doc.line(startX + 110, y, 200, y);

                        doc.setLineDash([]);
                    }

                    // move cursor after 4 rows
                    startY += (4 * rowHeight) + 0;

                    /* --- Opmerkingen --- */
                    autoTable(doc, {
                        startY,
                        margin: { left: 8, right: 13 },
                        body: [["Opmerkingen"]],
                        theme: "plain",
                        styles: { fontSize: 8 },
                        didDrawCell: function (data) {
                            if (data.section === 'body') {
                                const y = data.cell.y + data.cell.height - 2;
                                doc.setLineWidth(0.2);
                                doc.setDrawColor(150);
                                doc.setLineDash([1, 2]);
                                doc.line(data.cell.x + 20, y, data.cell.x + data.cell.width, y);
                                doc.setLineDash([]);
                                doc.setDrawColor(0);
                            }
                        }
                    });

                    startY = doc.lastAutoTable.finalY + 5;
            }

                /* PAGE NUMBERS */
                const pageCount = doc.internal.getNumberOfPages();

                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(8);

                    doc.text(`Page ${i} of ${pageCount}`, 105, 290, { align: "center" });
                }

                doc.save("Geboortelijst.pdf");

            } catch(e){
                console.error("Exception occurred in loadMatings()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }    
    },
    computed: {

        visiblePages() {

            const total = this.totalPages;
            const current = this.currentPage;

            const pages = [];

            // first page
            pages.push(1);

            // left dots
            if (current > 4) {
                pages.push('...');
            }

            // middle pages
            for (
                let i = Math.max(2, current - 2);
                i <= Math.min(total - 1, current + 2);
                i++
            ) {
                pages.push(i);
            }

            // right dots
            if (current < total - 3) {
                pages.push('...');
            }

            // last page
            if (total > 1) {
                pages.push(total);
            }

            return [...new Set(pages)];
        },

        allGroupedMatings() {
            const groups = {};

            this.matings.forEach(item => {
            let key = item.groupGuid;

            if (!key || typeof key !== 'string' || !key.trim()) {
                key = 'ungrouped';
            } else {
                key = key.trim().toLowerCase();
            }

            if (!groups[key]) {
                groups[key] = [];
            }

            groups[key].push(item);
            });

            return Object.values(groups); // all groups
        },

        groupedMatings() {
            const groups = {};
    
            this.matings.forEach(item => {

                let key = item.groupGuid;

                if (!key || typeof key !== 'string' || !key.trim()) {
                    key = 'ungrouped';
                } else {
                    key = key.trim().toLowerCase();
                }

                if (!groups[key]) {
                    groups[key] = [];
                }

                groups[key].push(item);
            });

            const grouped = Object.values(groups);

            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;

            return JSON.parse(JSON.stringify(grouped.slice(start, end)));
        },

        totalGroups() {
            return this.allGroupedMatings.length;
        },

        totalPages() {
            return Math.ceil(this.totalGroups / this.perPage);
        },

        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        groupedMatings1() {
            const groups = {};

            this.matings.forEach(item => {
            let key = item.groupGuid;
            
            if (!key || typeof key !== 'string' || !key.trim()) {
                key = 'ungrouped';
            } else {
                key = key.trim().toLowerCase();
            }

            if (!groups[key]) {
                groups[key] = [];
            }

            groups[key].push(item);
            });

            return Object.values(groups); // Array of arrays
        },                  
    }
}
</script>
<style scoped>
    ::v-deep .dataTable-bottom {
        display: none !important;
    }

    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .dead-animal-row {
        background-color: #f8d7da !important; /* light red */
        color: #721c24; /* dark red text */
    }
    .transferred-animal-row {
        background-color: #fdd199 !important;
        color: #643800;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .pagination-circles {
        gap: 6px;
    }

    .page-circle {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #dee2e6;
        background: white;
        color: #6c757d;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
        padding: 0;
    }

    /* Hover */
    .page-circle:hover:not(.active):not(.disabled) {
        background-color: #f2f2f2;
    }

    /* Active page */
    .page-circle.active {
        background-color: #4ca750;   /* your green */
        color: white;
        border-color: #4ca750;
    }

    /* Disabled prev/next */
    .page-circle.disabled,
    .page-circle:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .page-circle.dots {
        border: none;
        background: transparent;
        cursor: default;
    }
</style>